import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const GA_TRACKING_ID = "G-WDB1BX3DCG";

// 动态插入 gtag.js 脚本
const script = document.createElement("script");
script.async = true;
script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
document.head.appendChild(script);

// 初始化 GA
(window as any).dataLayer = (window as any).dataLayer || [];
function gtag(...args: any[]) {
  ((window as any).dataLayer as any).push(args);
}
gtag("js", new Date());
gtag("config", GA_TRACKING_ID);


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
